import styled from 'styled-components';
import { getColor, Fonts } from 'core/utils/Styles';
import Crt  from './Caret';

export const Wrapper = styled.div`
	& + & {
		margin: 30px 0px;
	}
`;

export const Trigger = styled.label`
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
`;

export const CategoryName = styled.h6`
	font-family: ${Fonts.serif};
	margin: 0;
	font-size: 19px;
	line-height: 20px;
	letter-spacing: 0.2px;
	margin-right: auto;
`;

export const IconWrapper = styled.div`
	margin-right: 16px;
	svg {
		display: block;
		width: 36px;
		height: 32px;
	}
`;

export const Caret = styled(Crt)`
	transform-origin: center;
	transform: rotate(-90deg);
	transition: transform 0.2s;
`;

export const SubCat = styled.a`
	font-family: ${Fonts.serif};
	display: block;
	font-size: 16px;
	line-height: 40px;
	letter-spacing: 0.2px;
	color: inherit;
	text-decoration: none;

	&:hover, &:focus {
		text-decoration: none;
	}
`;

export const CategoryLink = styled.a`
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	width: calc(100% - 44px);
	margin-right: auto;
	color: inherit;
`;

export const AllLink = styled(SubCat)`
	color: ${getColor('darkTeal')};
	font-weight: 700;
`;

export const HiddenCheck = styled.input.attrs({
	type: 'checkbox'
})`
	display: none;
	&:checked ~ ${Trigger} {
		${Caret} {
			transform: rotate(0);
		}
	}
`;

export const SubCats = styled.div`
	overflow: hidden;
	height: 0;
	transition: 0.2s;
	border-bottom: 1px solid transparent;

	/* stylelint-disable */
	${HiddenCheck}:checked ~ & {
		padding: 18px 0;
		height: ${({ totalHeight }) => totalHeight };
		border-bottom-color: ${getColor('alto')};
	}
	/* stylelint-enable */
`;
